import AddIcon from '@mui/icons-material/Add';
import { Box, Button, ClickAwayListener, Divider, IconButton, Popper, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useRef, useState } from "react";
import { ReactComponent as Sectors } from "../../assets/icons/sector.svg";
import { ReactComponent as Sentence } from "../../assets/icons/sentence.svg";
import theme from '../../theme';

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        minWidth: 275,
        width: '100%',
        height: 'fit-content',
        minHeight: 80,
        padding: '12px 16px',
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['400']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        transition: 'all 300ms ease',
    },
    hoverable :{
        "&:hover": {
            background: `rgb(246, 251, 251, 1)`,
        },
    },
    icon: {
        padding: 0,
        "& > svg": {
            width: '28px !important',
            height: '28px !important'
        },
    },
    icon2: {
        padding: 0,
        paddingLeft: 4,
        paddingRight: 4,
        "& > svg": {
            width: '20px !important',
            height: '20px !important',
        },
    },
    field: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#666666',
    },
    customBtn: {
        width: '18ch',
        height: 36,
        borderRadius: 16,
        borderColor: theme.colors.neutral['100'],
        background: '#E0F1F1',
        color: theme.palette.primary.main,
        fontSize: '0.85rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
}));

const AddCustomField: React.FC<{
    onNewTag: () => void,
    onNewField: () => void,
}> = ({ onNewTag, onNewField }) => {
    const classes = useStyles();
    const [open, setOpen] = useState<boolean>(false);
    const anchorRef = useRef<HTMLButtonElement>(null);

    return (<>
        <Button variant="outlined" ref={anchorRef}
            className={classes.customBtn}
            startIcon={<AddIcon />}
            onClick={() => setOpen(true)}
            disableRipple>{'Add field...'} </Button>
        <Popper open={open} anchorEl={anchorRef.current} placement="bottom-end" sx={{ zIndex: 1500 }}>
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box width="fit-content" height="fit-content">
                    <Stack className={classes.card} spacing={1} alignItems="flex-start" justifyContent="center">
                        <Stack className={classes.hoverable} spacing="4px" width="100%"
                            onClick={() => { setOpen(false); onNewTag(); }}
                            sx={{ cursor: 'pointer' }} >
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
                                <IconButton className={classes.icon} disabled>
                                    <Sectors style={{ stroke: 'rgb(163, 167, 172)' }} />
                                </IconButton>
                                <Stack direction="column" alignItems="flex-start" justifyContent="center" width="100%">
                                    <Typography className={classes.field}>
                                        {'Add tags field'}
                                    </Typography>
                                    <Typography fontFamily="Inter" fontSize="0.85rem" color={theme.colors.neutral['500']} fontWeight={400}>
                                        {'Tags get assigned using AI'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Divider sx={{ width: '100%' }}/>
                        <Stack className={classes.hoverable} spacing="4px" width="100%"
                            onClick={() => { setOpen(false); onNewField(); }}
                            sx={{ cursor: 'pointer' }} >
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
                                <IconButton className={classes.icon2} disabled>
                                    <Sentence style={{ stroke: 'rgb(163, 167, 172)' }} />
                                </IconButton>
                                <Stack direction="column" alignItems="flex-start" justifyContent="center" width="100%">
                                    <Typography className={classes.field}>
                                        {'Add text field'}
                                    </Typography>
                                    <Typography fontFamily="Inter" fontSize="0.85rem" color={theme.colors.neutral['500']} fontWeight={400}>
                                        {'Provides flexible outputs in free text form'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
            </ClickAwayListener>
        </Popper>
    </>);
}

export default AddCustomField;
